<template>
    <v-app id="base-layout">
        <Sidebar ref="sidebar" />
        <Navbar @toggle-drawer="$refs.sidebar.drawer = !$refs.sidebar.drawer" />
        <v-main class="my-3 mx-3">
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-main>
        <Footer />
        <Snackbar
            @close-snackbar="snackbar.status = false"
            v-model="snackbar.status"
            :text="snackbar.text"
            :color="snackbar.color"
            :timeout="snackbar.timeout"
        />
    </v-app>
</template>

<script>
import Sidebar from "../components/Sidebar.vue";
import Navbar from "../components/Navbar.vue";
import Footer from "../components/Footer.vue";
import Snackbar from "../components/Snackbar.vue";

import { eventBus } from "@/eventBus.js";

export default {
    name: "BaseLayout",
    components: {
        Sidebar,
        Navbar,
        Footer,
        Snackbar,
    },
    data() {
        return {
            isLoggedIn: false,
            snackbar: {
                status: false,
                text: "",
                color: "",
                timeout: -1,
            },
            isDataWarehouseView: false,
        };
    },
    // This gets called when "<keep-alive>" loads the component
    activated() {
        /* Listen for events */
        // Listen for event "close-sidebar", which closes the sidebar drawer
        eventBus.$on("close-sidebar", () => {
            if (this.$refs.sidebar) {
                this.$refs.sidebar.drawer = false;
            }
        });

        // Display only snackbar when not in "Data Warehouse" page
        if (!this.isDataWarehouseView) {
            // Listen for event "pusher-event-status" to display a message when the search result is done loading
            eventBus.$on("pusher-event-status", ({ content }) => {
                this.snackbar.status = false;

                // Get tab name
                const tabName = content.search_name;

                // Display snackbar and hide it after 20s
                this.snackbar = {
                    status: true,
                    // If we have a tab name, display it 
                    text: tabName.length
                        ? `Your search in Data Warehouse is ready!<div class="ml-6"><strong>Tab: ${tabName}</strong></div>`
                        : "Your search in Data Warehouse is ready!",
                    timeout: 20000,
                };
            });
        }
    },
    // This gets called when "<keep-alive>" unloads the component
    deactivated() {
        /* Remove event listeners */
        eventBus.$off("close-sidebar");
        eventBus.$off("pusher-event-status");
    },
    watch: {
        // Watch what page we are on
        $route: {
            handler: function (to, from) {
                // If we are on "Data Warehouse" page, do not display message
                if (to.path === "/search") {
                    this.isDataWarehouseView = true;
                } else {
                    this.isDataWarehouseView = false;
                }

                // If we do not close snackbar manually when we go to "Data Warehouse" page to check
                // when the result is done and go back to either "Dashboard" or "Settings" page,
                // the snackbar will be shown until timed out unless we set it to hidden
                if (from && from.path === "/search") {
                    if (this.snackbar.status) {
                        this.snackbar.status = false;
                    }
                }
            },
            immediate: true,
        },
    },
};
</script>

<style>
#base-layout {
    background: #f5f5f5;
}
</style>
